import { t as tr } from '@hana/i18n';
import './CostAdvance.i18n';
import { IconBell, IconCheck, IconEye, IconLock } from '@tabler/icons-react';
import { useList } from '@hana/data';
import { useToast } from '@hana/ui';
import type { Advance } from './types';
import { f1 } from './view';
import c from './cost.module.css';
import { useT } from '@hana/i18n';
import s from './extra.module.css';
import './finance.i18n';

// Mint-Cost › tab Tạm ứng: bảng 7 cột (CW 1240). Chỉ đọc; nút ghi báo toast.

const COLS = [
  { header: 'Người ứng', w: 190 },
  { header: 'Job / chuyến', w: 246 },
  { header: 'Đã ứng', w: 110, right: true },
  { header: 'Còn phải quyết toán', w: 160, right: true },
  { header: 'Ngày ứng · hạn', w: 170 },
  { header: 'Trạng thái', w: 200 },
  { header: '', w: 164, right: true },
] as const;
const TOTAL = COLS.reduce((a, x) => a + x.w, 0);
const STATUS = { open: 'Đang mở', over: 'Quá hạn · chặn ứng mới', done: 'Đã quyết toán' } as const;
const ACTION = { open: 'Quyết toán', over: 'Nhắc quyết toán', done: 'Xem' } as const;
const ICON = { open: IconCheck, over: IconBell, done: IconEye } as const;

export function CostAdvance({ q }: { q: string }) {
  const toast = useToast();
  const tx = useT();
  const rows = (useList('finAdvance', { limit: 500 }).data?.items ?? []) as readonly Advance[];
  const needle = q.trim().toLowerCase();
  const shown = rows.filter((a) => !needle || `${a.who} ${a.ref} ${a.what}`.toLowerCase().includes(needle));
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });

  return (
    <section className={c.card} aria-label="Tạm ứng">
      <table className={c.table} aria-label="Tạm ứng" aria-rowcount={shown.length + 1}>
        <colgroup>
          {COLS.map((x, i) => (
            <col key={i} style={{ width: `${((x.w / TOTAL) * 100).toFixed(3)}%` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {COLS.map((x, i) => (
              <th key={i} scope="col" className={'right' in x ? c.right : undefined}>
                {x.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {shown.map((a, i) => {
            const Ico = ICON[a.status];
            return (
              <tr key={a.ref} aria-rowindex={i + 2}>
                <td>
                  <b className={c.b}>{a.who}</b>
                  <div className={c.sub}>{a.seat}</div>
                </td>
                <td>
                  <span className={c.no}>{a.ref}</span>
                  <div className={c.sub}>{a.what}</div>
                </td>
                <td className={c.right}>
                  <b className={c.b}>{f1(a.amount)}</b>
                </td>
                <td className={c.right}>{f1(a.held)}</td>
                <td>
                  {a.date}
                  <div className={`${c.sub} ${a.status === 'over' ? s.over : ''}`}>{a.due}</div>
                </td>
                <td>
                  <span className={`${s.pill} ${s[`p_${a.status}`]}`}>{STATUS[a.status]}</span>
                </td>
                <td className={c.right}>
                  <button type="button" className={`${s.rowAct} ${a.status === 'done' ? s.view : ''}`} onClick={noWrite}>
                    <Ico size={16} aria-hidden="true" />
                    {ACTION[a.status]}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className={s.footBar}>
        <span>{tx('fn.advDue')}</span>
        <button type="button" className={s.footLink} onClick={() => toast({ msg: 'Quyết toán theo người chưa mở ở bản này' })}>
          <IconLock size={16} aria-hidden="true" />
          {tr('cadv.1')}
        </button>
      </div>
    </section>
  );
}
